import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const page = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "140px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  };

  const container = {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 20px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "60px",
  };

  const glass = {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "24px",
    padding: "40px",
    backdropFilter: "blur(12px)",
  };

  const inputStyle = {
    width: "100%",
    padding: "16px",
    marginBottom: "20px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    color: "#ffffff",
    fontSize: "1rem",
    outline: "none",
  };

  const btnPrimary = {
    width: "100%",
    padding: "18px",
    borderRadius: "50px",
    background: "#00d4ff",
    color: "#05070a",
    border: "none",
    fontWeight: "800",
    cursor: "pointer",
    fontSize: "1rem",
    textTransform: "uppercase",
    letterSpacing: "1px",
    boxShadow: "0 10px 25px rgba(0,212,255,0.2)",
    opacity: loading ? 0.7 : 1,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        alert("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        alert("Failed to send message. Please try WhatsApp.");
      }
    } catch (err) {
      console.error(err);
      alert("Server error. Please try WhatsApp.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={container}>
        {/* INFO */}
        <div>
          <h4 style={{ color: "#00d4ff", letterSpacing: "4px", textTransform: "uppercase" }}>
            Connect With Us
          </h4>
          <h1 style={{ fontSize: "3rem", fontWeight: "900" }}>
            Let's Build the <span style={{ color: "#00d4ff" }}>Future.</span>
          </h1>

          <p style={{ color: "#8b949e", marginTop: "20px" }}>
            Email: <a href="mailto:contact@digital-x-ai.com" style={{ color: "#fff" }}>
              contact@digital-x-ai.com
            </a>
          </p>
		  
		  
          <p style={{ color: "#8b949e" }}>
              WhatsApp: <a href="https://wa.me/97466828136" style={{ color: "#fff" }}>
              +974 6682 8136
            </a>
			
			<p style={{ color: "#8b949e" }}>
              Mobile: <a href="https://wa.me/97466828136" style={{ color: "#fff" }}>
              +91 9893049146
            </a>
          </p>
		  
		  
          </p>
        </div>

        {/* FORM */}
        <div style={glass}>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Full Name"
              style={inputStyle}
              required
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            <input
              type="email"
              placeholder="Work Email"
              style={inputStyle}
              required
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            />
            <textarea
              placeholder="Your message"
              rows="5"
              style={inputStyle}
              required
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
            />
            <button type="submit" style={btnPrimary} disabled={loading}>
              {loading ? "Sending..." : "Submit Inquiry"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;